import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { matchPath } from "react-router";

import { language } from "./DeviceDetection.js";

const browserPreferredLanguage = language.indexOf("de") === 0 ? "de" : "en";

export const languages = ["en", "de"];
export const localesShape = PropTypes.shape({
  en: PropTypes.string,
  de: PropTypes.string,
});

export default class CopyProvider extends React.Component {
  static childContextTypes = {
    copy: PropTypes.object,
  };
  static propTypes = {
    locale: PropTypes.oneOf(languages),
    locales: localesShape.isRequired,
  };
  static getLocale() {
    const m = matchPath(window.location.pathname, {
      isExact: false,
      path: "/:locale/",
    });
    if (m && m.params.locale) {
      return languages.indexOf(m.params.locale) > -1
        ? m.params.locale
        : browserPreferredLanguage;
    } else {
      return browserPreferredLanguage;
    }
  }
  state = {
    loaded: false,
    promise: null,
    content: {},
  };
  load(locale) {
    const path = this.props.locales[locale];
    // prettier-ignore
    const promise =
			import(
				/* webpackMode: "lazy" */
				/* webpackInclude: /\.js$/ */
				`./content/${path}`
			)
			.then(m => {
				this.setState({
					content: m.default,
					loaded: true,
				});
				return true;
			});
    this.setState({
      loaded: false,
      promise,
    });
    return promise;
  }
  _get = input => {
    let property =
      typeof input === "string"
        ? input
        : input.name
          ? input.name
          : input.constructor.name;
    return this.state.loaded ? this.state.content[property] || false : false;
  };
  //
  // For Wizard's more tricky data structure
  //
  getContent = state => {
    const contentGlobal = this.state.content[state] || {};
    const contentPerState = this.state.content[state.value] || {};
    return {
      ...contentGlobal,
      ...contentPerState,
    };
  };
  getTriggerName = (state, trigger) => {
    const content = this.state.content[state.value];
    if (content == null) {
      return false;
    }
    return (
      content[trigger] ||
      this.state.content[trigger].title ||
      this.state.content[trigger]
    );
  };
  //
  // Lifecycle
  //
  componentDidMount() {
    this.load(this.props.locale ? this.props.locale : CopyProvider.getLocale());
  }
  componentDidUpdate(prevProps) {
    if (prevProps.locale !== this.props.locale) {
      this.load(this.props.locale);
    }
  }
  render() {
    // console.log(this.props.children);
    return <Fragment>{this.props.children}</Fragment>;
  }
  getChildContext() {
    return {
      copy: {
        ...this.state,
        get: this._get,
        getContent: this.getContent,
        getTriggerName: this.getTriggerName,
      },
    };
  }
}

export const withCopy = ({ locales }, Component) => props => (
  <CopyProvider
    locale={props.locale || CopyProvider.getLocale()}
    locales={locales}
  >
    <Component {...props} />
  </CopyProvider>
);



// WEBPACK FOOTER //
// ./src/CopyProvider.js